<template>
  <section >
    <div class="row">
      <div class="col text-center problem-number-div">
        <p class="display-4">{{ this.message }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'Total',
    props: ['total'],
    data() {
      return {
        message: setMessage(this.total),        
      }
    },
    watch: {
      total(newValue) {
        this.message = setMessage(newValue)
      }
    }
}

let setMessage = function(value) {
      let message = `${value} énoncés trouvés`
      if (value == 0) { message = `Aucun énoncé trouvé` }
      if (value == 1) { message = `Un énoncé trouvé` }
      return message
}

</script>